import {X} from 'lucide-react'
import {getTraditionalProductDetail} from './mockData'

const detailGroups = [
	{
		title: 'Identificación',
		items: [
			['Producto', 'producto'],
			['Zona', 'zona'],
			['Tipo', 'tipo'],
			['UNIT', 'unit'],
			['Factor', 'factor'],
			['UMV (UND)', 'umv'],
		],
	},
	{
		title: 'Elasticidad y margen',
		items: [
			['Elasticidad Promedio', 'elasticidadPromedio'],
			['N° Escala de Precios', 'escalaPrecios'],
			['Margen Empírico', 'margenEmpirico'],
			['Margen Óptimo', 'margenOptimo'],
			['Delta Mg $', 'deltaMgValor'],
			['Delta Mg %', 'deltaMgPorcentaje'],
		],
	},
	{
		title: 'Resultado recomendado',
		items: [
			['Precio Actual (UND)', 'precioActual'],
			['Precio Recomendado (UND)', 'precioRecomendado'],
			['Volumen Actual (UND)', 'volumenActual'],
			['Volumen Recomendado (UND)', 'volumenRecomendado'],
			['Var%Precio', 'varPrecio'],
			['Var%Vol', 'varVolumen'],
		],
	},
]

const priceScaleColumns = [
	{price: 'precioEscala1', volume: 'volumenEscala1', title: 'Escala 1'},
	{price: 'precioEscala2', volume: 'volumenEscala2', title: 'Escala 2'},
	{price: 'precioEscala3', volume: 'volumenEscala3', title: 'Escala 3'},
]

export const TarjetaPFTradicional = ({row, onClose}) => {
	const detail = getTraditionalProductDetail(row) || row

	return (
		<div className='TarjetaPFTradicionalOverlay' onClick={onClose}>
			<div className='TarjetaPFTradicionalModal' onClick={(event) => event.stopPropagation()}>
				<button type='button' className='traditional-pf-close' onClick={onClose} aria-label='Cerrar'>
					<X size={18} />
				</button>
				<header className='traditional-pf-header'>
					<div>
						<p className='traditional-pf-kicker'>Vista Producto Tradicional</p>
						<h1>{row?.producto} | {row?.descripcion}</h1>
					</div>
					<div className='traditional-pf-zone'>Zona {row?.zona}</div>
				</header>

				<section className='traditional-pf-summary'>
					<div>
						<span>Familia</span>
						<strong>{row?.familia}</strong>
					</div>
					<div>
						<span>SubFamilia</span>
						<strong>{row?.subFamilia}</strong>
					</div>
					<div>
						<span>Elasticidad Producto</span>
						<strong>{row?.elasticidadProducto}</strong>
					</div>
					<div>
						<span>Precio Recomendado</span>
						<strong>{detail?.precioRecomendado}</strong>
					</div>
				</section>

				<section className='traditional-pf-content'>
					{detailGroups.map((group) => (
						<div className='traditional-pf-card' key={group.title}>
							<h2>{group.title}</h2>
							<div className='traditional-pf-grid'>
								{group.items.map(([label, key]) => (
									<div className='traditional-pf-field' key={key}>
										<span>{label}</span>
										<strong>{detail?.[key] ?? '-'}</strong>
									</div>
								))}
							</div>
						</div>
					))}

					<div className='traditional-pf-card traditional-pf-scale-card'>
						<h2>Escalas de Precio</h2>
						<div className='traditional-pf-scale-table'>
							{priceScaleColumns.map((column) => (
								<div className='traditional-pf-scale' key={column.title}>
									<h3>{column.title}</h3>
									<div>
										<span>Precio</span>
										<strong>{detail?.[column.price] ?? '-'}</strong>
									</div>
									<div>
										<span>Volumen</span>
										<strong>{detail?.[column.volume] ?? '-'}</strong>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>
			</div>
		</div>
	)
}
